// @ts-check
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA, { callObtenerArticulos } from '@/js/services/traceability/APITraceability';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { TipoArticulo } from '../common/enum';

/** @import { LineaProduccion, PuntoPaletizado } from '@erpagroapp/types' */

export default class TraceabilityController {
  /** Initializes the controller. */
  static Initialize() {
    Log(this, this.Initialize.name);
    this.CargarDatosNecesariosTrazabilidad();
  }

  static CargarDatosNecesariosTrazabilidad() {
    this.ObtenerTodasLasCantidadesNormalizadasPorEnvaseYProducto();
    this.ObtenerTodasLosArticulosDeTipoEnvaseDisponibles();
    this.ObtenerTodasLasUbicacionesDisponibles();
    this.ObtenerTodasLasLineasDeProduccionDisponibles();
    this.ObtenerLineaPorDefectoDefinidaDelUsuarioAutentificado();
  }

  static ObtenerTodasLasCantidadesNormalizadasPorEnvaseYProducto() {
    ConexionTA.callObtenerTodasLasCantidadesNormalizadasPorEnvaseYProducto().then((result) => {
      if (result.Valor) {
        const cantidadesPorEnvase = JSON.parse(result.Mensaje);
        const store = useTraceabilityStore();

        store.cantidadesNormalizadasPorEnvaseYProducto = cantidadesPorEnvase;
      }
    })
      .catch((error) => {
        LogError(this, this.ObtenerTodasLasCantidadesNormalizadasPorEnvaseYProducto.name, error);
      });
  }

  static ObtenerTodasLosArticulosDeTipoEnvaseDisponibles() {
    callObtenerArticulos({ tipoArticulo: TipoArticulo.Envase }).then((result) => {
      if (result.Valor) {
        const tempArticulosDeTipoEnvase = result.Mensaje ? JSON.parse(result.Mensaje) : [];
        const store = useTraceabilityStore();

        store.articulosDeTipoEnvase = tempArticulosDeTipoEnvase;
      }
    })
      .catch((error) => {
        LogError(this, this.ObtenerTodasLosArticulosDeTipoEnvaseDisponibles.name, error);
      });
  }

  static ObtenerTodasLasUbicacionesDisponibles() {
    ConexionTA.callObtenerUbicaciones().then((result) => {
      if (result.Valor) {
        const tempUbicaciones = JSON.parse(result.Mensaje);
        const store = useTraceabilityStore();

        store.ubicacionesAlmacen = tempUbicaciones;
      }
    })
      .catch((error) => {
        LogError(this, this.ObtenerTodasLasUbicacionesDisponibles.name, error);
      });
  }

  static ObtenerTodasLasLineasDeProduccionDisponibles() {
    ConexionTA.callObtenerLineasDeProduccion().then((result) => {
      if (result.Valor) {
        /** @type {LineaProduccion[]} */
        const tempLineasDeProduccion = JSON.parse(result.Mensaje);
        const store = useTraceabilityStore();

        tempLineasDeProduccion.forEach((l) => {
          // Si la linea de producción tiene dispositivo de base de datos unicamente nos quedaremos con los puntos de paletizado que tengan marcado uso en integración.
          if (l.DispositivoBaseDatos !== null) {
            /** @type {PuntoPaletizado[]} */
            const puntosPaletizado = [];
            if (l.PuntosDePaletizado != null) {
              l.PuntosDePaletizado.forEach((p) => {
                if (p.UsoEnIntegracion) {
                  puntosPaletizado.push(p);
                }
              });

              l.PuntosDePaletizado = puntosPaletizado;
            }
          }
        });

        store.lineasDeProduccion = tempLineasDeProduccion;
      }
    })
      .catch((error) => {
        LogError(this, this.ObtenerTodasLasLineasDeProduccionDisponibles.name, error);
      });
  }

  static ObtenerLineaPorDefectoDefinidaDelUsuarioAutentificado() {
    ConexionTA.callObtenerLineaPorDefectoDefinidaDelUsuario().then((result) => {
      if (result.Valor) {
        /** @type {LineaProduccion} */
        const tempLineaDeProduccion = JSON.parse(result.Mensaje);
        const store = useTraceabilityStore();

        if (tempLineaDeProduccion.DispositivoBaseDatos !== null) {
          /** @type {PuntoPaletizado[]} */
          const puntosPaletizado = [];

          tempLineaDeProduccion.PuntosDePaletizado?.forEach((p) => {
            if (p.UsoEnIntegracion) {
              puntosPaletizado.push(p);
            }
          });

          tempLineaDeProduccion.PuntosDePaletizado = puntosPaletizado;
        }

        store.lineasDeProduccionDelUsuarioDefinidaEnERP = tempLineaDeProduccion;
      }
    })
      .catch((error) => {
        LogError(this, this.ObtenerLineaPorDefectoDefinidaDelUsuarioAutentificado.name, error);
      });
  }
}
